import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../shared/Modal'

const BODY_TEXT_CLASS = 'tw:m-0! tw:text-sm tw:text-gray-700'
const NAME_CLASS = 'tw:font-semibold'

const ConfirmDeleteModal = ({ isOpen, alertName = '', isDeleting = false, onCancel, onConfirm }) => {
  const footer = (
    <>
      <button
        className="btn btn-light border"
        disabled={isDeleting}
        type="button"
        onClick={onCancel}
      >
        Annuler
      </button>
      <button
        className="btn btn-danger"
        disabled={isDeleting}
        type="button"
        onClick={onConfirm}
      >
        Supprimer
      </button>
    </>
  )

  return (
    <Modal footer={footer} isOpen={isOpen} title="Supprimer l’alerte ?" onClose={onCancel}>
      <p className={BODY_TEXT_CLASS}>
        Cette action supprimera l’alerte
        {' « '}
        <span className={NAME_CLASS}>{alertName}</span>
        {' » '}
        et toutes les alertes déclenchées associées. Cette action est irréversible.
      </p>
    </Modal>
  )
}

ConfirmDeleteModal.propTypes = {
  alertName: PropTypes.string,
  isDeleting: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

ConfirmDeleteModal.defaultProps = {
  alertName: '',
  isDeleting: false
}

export default ConfirmDeleteModal
